import script from "./base-combobox.vue?vue&type=script&setup=true&lang=js"
export * from "./base-combobox.vue?vue&type=script&setup=true&lang=js"

import "./base-combobox.vue?vue&type=style&index=0&id=696cf24f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696cf24f"]])

export default __exports__